import { Marker } from "../models/marker.model";
import {
  areTwoFiguresColliding,
  rotatePointAroundAnotherPoint,
} from "../../../../utils/functions/MathUtil";

interface Point {
  x: number;
  y: number;
}

function getCorrectVertices(
  x: number,
  y: number,
  width: number,
  height: number,
  angle: number
): Point[] {
  // Center of the unrotated rectangle
  const cx = x + width / 2;
  const cy = y + height / 2;

  // Unrotated corners
  const corners = [
    { x: x, y: y }, // Top-Left
    { x: x + width, y: y }, // Top-Right
    { x: x + width, y: y + height }, // Bottom-Right
    { x: x, y: y + height }, // Bottom-Left
  ];

  // Rotate corners around the center
  return corners.map((p) =>
    rotatePointAroundAnotherPoint(p.x, p.y, cx, cy, angle)
  );
}

export function isLogoOverlappingAnotherLogo(
  marker: Marker,
  allMarkers: Marker[]
): boolean {
  // If marker is the only marker on the view there is no need to check for overlap
  if (allMarkers.length < 2) {
    return false;
  }

  // Find corners/vertices of marker using correct center rotation
  const logoVertices = getCorrectVertices(
    marker.x,
    marker.y,
    marker.widthPx,
    marker.heightPx,
    marker.rotationRad
  );

  for (const l of allMarkers) {
    // Logo will always overlap with itself, so continue loop
    if (l.id === marker.id) {
      continue;
    }

    const lVertices = getCorrectVertices(
      l.x,
      l.y,
      l.widthPx,
      l.heightPx,
      l.rotationRad
    );
    if (areTwoFiguresColliding(logoVertices, lVertices)) {
      return true;
    }
  }

  return false;
}
